export default __webpack_public_path__ + "static/underwater-374a0a1cc29e8d3ca1d9101090322604.mp3";